import script from "./withholdingIssue.vue?vue&type=script&setup=true&lang=js"
export * from "./withholdingIssue.vue?vue&type=script&setup=true&lang=js"

import "./withholdingIssue.vue?vue&type=style&index=0&id=07c41296&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07c41296"]])

export default __exports__